export default __webpack_public_path__ + "static/tag-do-1-light-971adad8b9b7dbd27c05cb78eda2e2dbe3b8afad89546d52f7dde23a7f866bac.png";